import me from "./img/me.png";
import me2 from "./img/me-2.png";
import html from "./img/html.svg";
import css from "./img/css.svg";
import js from "./img/js.svg";
import react from "./img/react.svg";
import bootstrap from "./img/bootstrap.svg";
import tailwind from "./img/tailwind.png";
import php from "./img/php.svg";
import laravel from "./img/laravel.png";
import centos from "./img/centos.svg";
import debian from "./img/debian.svg";
import image from "./img/image.png";
import image1 from "./img/image (1).png";
import image2 from "./img/image (2).png";
import image3 from "./img/image (3).png";
import image4 from "./img/image (4).png";
import "./App.css";

function App() {
  const portofolios = [
    {
      title: "Dodotracking",
      site: "https://dodotracking.com",
      image: image,
    },
    {
      title: "KBRIcoop",
      site: "https://kbricoop.com",
      image: image1,
    },
    {
      title: "Elkapitan Indonesia",
      site: "https://elkapitan.co.id",
      image: image2,
    },
    {
      title: "TopUpYuk",
      site: "https://topupyuk.com",
      image: image3,
    },
    {
      title: "iTradeFund CGS International",
      site: "https://itradefund.cgsi.co.id",
      image: image4,
    },
  ];

  return (
    <>
      <header
        className="hidden md:block fixed top-0 w-full py-5 bg-gray-900"
        style={{ zIndex: 9999 }}
      >
        <div className="flex justify-around w-2/3 mx-auto">
          <a href="#home" className="text-white">
            Home
          </a>
          <a href="#about" className="text-white">
            About Me
          </a>
          <a href="#project" className="text-white">
            My Portofolios
          </a>
          <a href="#contact" className="text-white">
            Contact Me
          </a>
        </div>
      </header>
      <div className="bg-gray-900" style={{ minHeight: "100vh" }}>
        <main className="container mx-auto pt-10 md:pt-0 px-4 md:px-0">
          <section id="home">
            <div
              className="md:flex items-center justify-around"
              style={{ minHeight: "100vh" }}
            >
              <div className="order-2 md:order-1" style={{ maxWidth: "500px" }}>
                <h6 className="text-2xl text-indigo-500 mb-4 font-medium">
                  Hi, I am
                </h6>
                <h1 className="text-4xl font-bold text-white mb-4">
                  ZACKY ZALFA FAHRUR ROZY
                </h1>
                <p className="text-gray-400 mb-4">
                  I am a full-stack developer with expertise in creating web
                  applications from frontend to backend. With experience in
                  various technologies such as HTML, CSS, JavaScript, and
                  frameworks like React and Node.js, I am equipped to handle
                  diverse challenges in software development comprehensively.
                </p>
                <div className="grid grid-cols-5 md:grid-cols-10">
                  <img className="m-2 h-8" src={html} alt="HTML" />
                  <img className="m-2 h-8" src={css} alt="CSS" />
                  <img className="m-2 h-8" src={js} alt="JavaScript" />
                  <img className="m-2 h-8" src={react} alt="React" />
                  <img className="m-2 h-8" src={bootstrap} alt="Bootstrap" />
                  <img className="m-2 h-8" src={tailwind} alt="Tailwind" />
                  <img className="m-2 h-8" src={php} alt="PHP" />
                  <img className="m-2 h-8" src={laravel} alt="Laravel" />
                  <img className="m-2 h-8" src={centos} alt="CentOS" />
                  <img className="m-2 h-8" src={debian} alt="Debian" />
                </div>
              </div>
              <div className="mt-20 md:mt-0 order-1 md:order-2">
                <div
                  className="bg-indigo-500 rotate-45 mx-auto w-280px h-280px md:w-480px md:h-480px"
                  style={{
                    width: "280px",
                    height: "280px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={me}
                    className="-rotate-45"
                    style={{
                      width: "330px",
                      position: "relative",
                      top: "-80px",
                      left: "20px",
                    }}
                    alt="Portrait"
                  />
                </div>
              </div>
            </div>
          </section>

          <section id="about" style={{ minHeight: "100vh" }}>
            <h2 className="text-center text-white text-4xl font-medium mb-4 pt-20">
              About Me
            </h2>
            <div className="md:flex items-center justify-center">
              <div
                style={{ width: "280px", height: "280px", overflow: "hidden" }}
                className="rounded mx-auto"
              >
                <img src={me2} alt="" className="-mt-10" />
              </div>
              <div style={{ maxWidth: "700px" }}>
                <p className="text-gray-400 m-4">
                  I am currently working full-time freelance as a full-stack
                  developer at a software house. I am from Kabupaten Tangerang
                  and graduated from SMKN 1 Kabupaten Tangerang in 2024. I
                  started coding in 2020 and began working in the field as a
                  freelancer and in personal business ventures since 2021. In
                  addition to my passion for coding, I am also interested in
                  learning about business, management, and delegation.
                </p>
              </div>
            </div>
          </section>
          <section id="project" style={{ minHeight: "100vh" }}>
            <h2 className="text-center text-white text-4xl font-medium mb-4 pt-20">
              My Portofolio
            </h2>
            <div className="grid md:grid-cols-2 gap-x-4 mt-40">
              {portofolios.map((portofolio) => (
                <div className="-mt-16">
                  <div className="rounded overflow-hidden">
                    <img src={portofolio.image} alt="Image" />
                  </div>
                  <div
                    className="relative -top-20 p-4"
                    style={{ background: "rgb(0,0,0,0.5)", zIndex: 90 }}
                  >
                    <h6 className="text-white text-lg font-medium">
                      {portofolio.title}
                    </h6>
                    <a href={portofolio.site} className="text-white text-sm">
                      {portofolio.site}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </section>
          <section id="contact" style={{ minHeight: "100vh" }}>
            <h2 className="text-center text-white text-4xl font-medium mb-4 pt-20">
              Contact Me
            </h2>
            <div className="text-center mt-20">
              <a
                href="https://wa.me/62895393725633"
                className="text-xl text-white"
              >
                WhatsApp : +62 895-3937-25633 (Just Click)
              </a>
            </div>
          </section>
        </main>
      </div>
    </>
  );
}

export default App;
